export default "__VITE_ASSET__B3rCHpQQ__"